var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 172 172"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.133 86a5.718 5.718 0 01-1.68 4.053L67.12 147.387a5.733 5.733 0 01-9.787-4.054V28.667a5.733 5.733 0 019.787-4.053l57.333 57.333a5.718 5.718 0 011.68 4.053z",
    fill: "#ccc"
  }))));
}

export default SvgVector;